<template>
  <div>
    <j-modal centered
      :title="title"
      :width="1000"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭">
      <div  class="table-operator" style="margin-bottom:20px" >
        <a-form layout="inline">
          <a-row>
            <a-col>
              <a-select style="width: 120px" v-model="departmenteChoose" @change="handleDepartmentChange"  placeholder="请选择部门"  >
                <a-select-option v-for="item in departmenteData" :key="item.id"    >
                  {{ item.depart }}
                </a-select-option>
              </a-select>
              <a-select mode="multiple" v-model="workshopChoose" style="width: 300px;margin-left:20px"  placeholder="请选择区域"  >
                <a-select-option v-for="(item,index) in workshopData" :key="index"   >
                  {{ item.workshop }}
                </a-select-option>
              </a-select>
              <a-button type="primary"
                  style="margin-left:20px"
                  @click="handleAddUserWorkshop"
                  icon="search">添加</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-operator" :md="24" :sm="24" style="">
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="handleDelUserWorkshop">
                <a-icon type="delete"/>
                删除
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> 批量操作
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </div>
      <div>
        <a-table size="small"
          bordered
          rowKey="id"
          :columns="columns1"
          :dataSource="dataSource1"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ y: 240 }"
          :rowSelection="{selectedRowKeys: selectedRowKeys,onSelectAll:onSelectAll,onSelect:onSelect,onChange: onSelectChange}"
          @change="handleTableChange">
        </a-table>
      </div>
      <!-- table区域-end -->

    </j-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAction,postAction,deleteAction  } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
export default {
  name: "SelectUserModal",
  components: {
   JInput
   },
  data () {
    return {
      roleId:"",
      title: "添加巡查区域",
      roleTypes:"",
      roleCode:"",
      departmenteData:[],
      workshopData:[],
      departmenteChoose:[],
      workshopChoose:[],
      names: [],
      visible: false,
      placement: 'right',
      description: '',
      // 查询条件
      queryParam: {},
      userId:"",
      userNo:"",
      userName:"",
      // 表头
      columns1: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 50,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '基地',
          align: "center",
          width: 100,
          dataIndex: 'inspectionWorkshop'
        },
        {
          title: '部门',
          align: "center",
          width: 100,
          dataIndex: 'inspectionDepart'
        },
        {
          title: '区域',
          align: "center",
          width: 100,
          dataIndex: 'inspectionBase'
        },
      ],
      //数据集
      dataSource1: [],
      dataSource2: [],
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      url: {
        list: "/general/busInspectionUserWorkshop/getList",
      }
    }
  },
  created () {
    this.loadData();
  },
  methods: {
    handleAddUserWorkshop(){
      if(this.departmenteChoose.length==0){
        this.$message.error("请选择部门");
        return
      }
      if(this.workshopChoose.length==0){
        this.$message.error("请选择区域");
        return
      }
      if(!this.userNo||!this.userId){
        this.$message.error("找不到用户，请从正确的方式打开页面");
        return
      }
      let params={
        roleType:this.roleTypes,
        userId:this.userId,
        userNo:this.userNo,
        roleId:this.roleId,
        userName:this.userName,
        workshopList:[]
      }
      this.workshopChoose.forEach(i => {
        params.workshopList.push(
          {
            workshopId:this.workshopData[i].id,
            ...this.workshopData[i]
          }
        
        )
      })
      postAction("/general/busInspectionUserWorkshop/addUserWorkshop",params).then((res)=>{
        if(res.code==200){
          this.$message.success("添加成功")
          this.findSourceData();
        }else{
          this.$message.error(res.message)
        }
        
      }).catch((res)=>{
        this.$message.error(res);
      })
    },
    handleDelUserWorkshop(){
      var ids = "";
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
      }
      deleteAction("/general/busInspectionUserWorkshop/deleteBatch",{ids:ids}).then((res)=>{
        if(res.success){
          this.$message.success("删除成功")
          this.findSourceData();
        }else{
          this.$message.success(res.message)
        }
      }).catch(err=>{
        this.$message.err(err);
      })
    },
    findSourceData(){
      this.loadData(1)
    },
    handleDepartmentChange(item){
      postAction(`/general/inspection/api/findWorkshopListByID?departId=${item}&roleType=${this.roleTypes}`,{}).then((res) => {
        if (res.success) {
          this.workshopData=res.result
        }
      }).finally(()=>{
        this.clearWorkshopSelect()
      })
    },
    clearWorkshopSelect(){
      this.workshopChoose=[]
    },
    searchQuery () {
      this.loadData(1);
    },
    searchReset () {
      this.queryParam = {};
      this.loadData(1);
    },
    handleCancel () {
      this.departmenteChoose=undefined,
      this.workshopChoose=[],
      this.workshopData=[],
      this.departmenteData=[],
      this.visible = false;
    },
    handleOk () {
      this.dataSource2 = this.selectedRowKeys;
      console.log("data:" + this.dataSource2);
      this.$emit("selectFinished", this.dataSource2);
      this.selectedRowKeys = [];
      this.departmenteChoose=undefined,
      this.workshopChoose=[],
      this.workshopData=[],
      this.departmenteData=[],
      this.visible = false;
    },
    open (record,roleTypes,roleCode,currentRoleId) {
      this.roleTypes=roleTypes;
      this.roleCode=roleCode;
      this.roleId=currentRoleId
      this.userId=record.id
      this.userNo=record.username
      this.userName=record.realname
      this.findSourceData();
      postAction("/general/inspection/api/findDepartListWithID/"+roleTypes).then((res) => {
        if (res.success) {
          this.departmenteData=res.result?res.result:[];
          // if(this.departmenteData.length>0){
          //   this.handleDepartmentChange(this.departmenteData[0].id)
          // }
        }
      })

      this.visible = true;
    },
    loadData (arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource1 = res.result.records;
          this.ipagination.total = res.result.total;
        }
      })
    },
    getQueryParams () {
      var param = Object.assign({userId:this.userId,userNo:this.userNo,roleId:this.roleId,roleType:this.roleTypes}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField () {
      //TODO 字段权限控制
    },
    onSelectAll (selected, selectedRows, changeRows) {
      if (selected === true) {
        for (var a = 0; a < changeRows.length; a++) {
          this.dataSource2.push(changeRows[a]);
        }
      } else {
        for (var b = 0; b < changeRows.length; b++) {
          this.dataSource2.splice(this.dataSource2.indexOf(changeRows[b]), 1);
        }
      }
      // console.log(selected, selectedRows, changeRows);
    },
    onSelect (record, selected) {
      if (selected === true) {
        this.dataSource2.push(record);
      } else {
        var index = this.dataSource2.indexOf(record);
        //console.log();
        if (index >= 0) {
          this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
        }

      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectedRows;
    },
    onClearSelected () {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    handleDelete: function (record) {
      this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
    },
    handleTableChange (pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      console.log(sorter);
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.loadData();
    }
  }
}
</script>
<style lang="less" scoped>
.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
</style>